import React from 'react';
import { motion } from 'framer-motion';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  text = 'Chargement en cours...' 
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
  };

  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <motion.div
        className={`${sizeClasses[size]} border-4 border-gray-200 border-t-yellow-400 rounded-full`}
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
      />
      {text && (
        <p className="text-gray-600 font-[DMSans] text-sm">{text}</p>
      )}
    </div>
  );
};

interface LoadingScreenProps {
  text?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  text = 'Chargement en cours...' 
}) => {
  return (
    <div className="flex flex-col justify-center items-center h-screen bg-gray-50 px-4">
      <div className="flex flex-col items-center justify-center gap-6 sm:gap-10">
        <span className="text-black font-[DMSans] text-lg sm:text-xl font-bold text-center">
          {text}
        </span>
        <motion.svg
          className="border-indigo-600 w-16 h-16 sm:w-20 sm:h-20"
          xmlns="http://www.w3.org/2000/svg"
          width="76"
          height="75"
          viewBox="0 0 76 75"
          fill="none"
        >
          <g id="Group 1000003700">
            <circle
              id="Ellipse 715"
              cx="38.0004"
              cy="37.1953"
              r="28"
              stroke="#E5E7EB"
              strokeWidth="8"
            />
            <motion.path
              id="Ellipse 716"
              d="M49.8079 62.5848C53.142 61.0342 56.138 58.842 58.6248 56.1335C61.1117 53.425 63.0407 50.2532 64.3018 46.7992C65.5629 43.3452 66.1313 39.6767 65.9745 36.003C65.8178 32.3293 64.939 28.7225 63.3884 25.3884C61.8378 22.0544 59.6456 19.0584 56.9371 16.5715C54.2286 14.0847 51.0568 12.1556 47.6028 10.8946C44.1488 9.63351 40.4802 9.06511 36.8066 9.22183C33.1329 9.37855 29.5261 10.2573 26.192 11.808"
              stroke="url(#paint0_linear_13416_7443)"
              strokeWidth="8"
              strokeLinecap="round"
              animate={{ rotate: 360 }}
              transition={{ duration: 2, repeat: Infinity, ease: 'linear' }}
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_13416_7443"
              x1="0.803595"
              y1="23.6159"
              x2="24.4195"
              y2="74.3928"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#06B2DC" />
              <stop offset="1" stopColor="#F4C631" />
            </linearGradient>
          </defs>
        </motion.svg>
      </div>
    </div>
  );
};

export { LoadingSpinner, LoadingScreen };
